import { OpportunityCompanyView } from '@api-proxies';
import { CustomCellActionsComponent } from '@app/components/shared/grids/custom-cell-actions/custom-cell-actions.component';
import { TabNames } from '@enums/TabNames';
import { ColDef, ICellRendererParams } from 'ag-grid-enterprise';

export const OPPORTUNITY_COMPANIES_GRID_COLUMNS: ColDef[] = [
    {
        colId: 'companyId',
        field: 'companyId',
        headerName: 'ID',
        width: 100,
        lockPinned: true,
        lockPosition: 'left',
        suppressSizeToFit: true,
        cellRenderer: (params: ICellRendererParams<OpportunityCompanyView>) => {
            if (params.value) {
                const link = `/companies-single/${params.value}/${TabNames[TabNames.Overview]}`;
                return `<a class="anchor" href="${link}">${params.value}</a>`;
            }
            return '';
        }
    },
    {
        colId: 'companyName',
        field: 'companyName',
        headerName: 'Name',
        cellDataType: 'text',
        sortable: true
    },
    {
        colId: 'companyRoleDescriptions',
        field: 'companyRoleDescriptions',
        headerName: 'Roles',
        cellDataType: 'text',
        sortable: true
    },
    {
        colId: 'fullAddress',
        field: 'fullAddress',
        headerName: 'Main Office Address',
        cellDataType: 'text',
        sortable: false
    },
    {
        colId: 'companyTypeName',
        field: 'companyTypeName',
        headerName: 'Type',
        cellDataType: 'text',
        sortable: true
    },
    {
        colId: 'markets',
        field: 'markets',
        headerName: 'Markets',
        cellDataType: 'text',
        sortable: true
    },
    {
        colId: 'actions',
        headerName: '',
        maxWidth: 80,
        sortable: false,
        filter: false,
        resizable: false,
        suppressHeaderMenuButton: true,
        suppressSizeToFit: true,
        cellRenderer: CustomCellActionsComponent,
        cellClass: 'action-cell'
    }
];
